import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddProductsModal = ({ formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [party, setParty] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [partyNameId, setPartyNameId] = useState("");
  const [partyName, setPartyName] = useState([]);
  const [partyID, setPartyId] = useState("");
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState([]);

  const [materialId, setMaterialID] = useState("");
  const [rowAddData, setRowAddData] = useState({
    product_name: "",
    size: "",
  });
  // console.log(partyName)

  function resetFileds() {
    setSelectedCompanyId("");
    setProductId("");
    setRowAddData({
      product_name: "",
      size:""
    });
  }

  const handleMaterialChange = (e) => {
    setMaterialID(e.target.value);
  };

  const handleProductChange = (e) => {
    setProductId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { company_id, party_name_id, material_id, product_name, size } =
      rowAddData;

    let BASE_URL = SERVER_URL + `/api/product/products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        product_name,
        size,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    setSelectedCompanyId(e.target.value);
  };

  const getSinglePartyName = async (e) => {
    let BASE_URL = SERVER_URL + `/api/raw-mat/partyName/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: e.target.value,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setPartyName(response.data);
    } else {
      toast.error(response.message);
    }
  };
  const getSingleMaterialName = async (e) => {
    setPartyId(e.target.value);
    let BASE_URL = SERVER_URL + `/api/raw-mat/materialName/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        party_name_id: e.target.value,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setParty(response.data);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="productModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Products
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Products</h4> */}
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      {/* <div className="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getSinglePartyName(e)}
                              value={selectedCompanyId}
                            >
                              <option>Select</option>
                              {company?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name} ${item.type}, ${item.location}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Party Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getSingleMaterialName(e)}
                              value={partyID}
                            >
                              <option>Select</option>
                              {partyName?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.party_name}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleMaterialChange}
                              value={materialId}
                            >
                              <option>Select</option>
                              {party?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.material_name}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Company_Name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              id="Company_Name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, index) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={index}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="product">Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="product_name"
                              id="product"
                              placeholder="Product Name"
                              onChange={handleChange}
                              value={rowAddData.product_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="size">Size/Type</label>
                            <select
                              type="text"
                              className="form-control"
                              name="size"
                              id="size"
                              placeholder="size"
                              onChange={handleChange}
                              required
                              value={rowAddData.size}
                            >
                              <option value="">Select Size/Type</option>
                              <option value="8MTR_plain">8MTR_plain</option>
                              <option value="8MTR_color">8MTR_color</option>
                              <option value="9.1MTR_plain">9.1MTR_plain</option>
                              <option value="9.1MTR_color">9.1MTR_color</option>
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="size">Size</label>
                            <input
                              type="text"
                              className="form-control"
                              name="size"
                              id="size"
                              placeholder="size"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="incoming">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="incoming"
                              placeholder="Date"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductsModal;
